import React, { useState, ReactElement } from "react";
import Parse from "parse";
import { Col, Form } from "react-bootstrap";
import { UserBaseModel } from "../../models/UserBaseModel";
import { PasswordType } from "../../settings/Enums";
import {
  DialogComponent,
  ButtonPropsModel,
} from "@syncfusion/ej2-react-popups";

interface Props {
  data: UserBaseModel;
}

export const AdminDialogFormTemplate: React.FC<Props> = (
  props: Props
): ReactElement => {
  const { data } = props;
  const [passwordType, setPasswordType] = useState<string>(PasswordType.Text);
  const [uniqueField, setUniqueField] = useState<string>("");
  const [isErrorDialogVisible, setIsErrorDialogVisible] =
    useState<boolean>(false);

  const checkMail = async (event: any): Promise<void> => {
    if (!(event && event.target && event.target.value)) return;
    const element = event.target;

    const person = Parse.Object.extend("Person");
    const personQuery = new Parse.Query(person).limit(10000);
    const results = await personQuery.equalTo("email", element.value).find();

    if (results && results.length > 0) {
      const result = results[0];
      if (
        result &&
        result.id &&
        result.attributes?.email &&
        result.id !== data.id
      ) {
        setUniqueField(result.attributes?.email);
        setIsErrorDialogVisible(true);
        element.value = "";
        return;
      }
    }
    setUniqueField("");
    setIsErrorDialogVisible(false);
  };

  const handleClick = (passwordType: string): void => {
    setPasswordType(
      passwordType === "text" ? PasswordType.Password : PasswordType.Text
    );
  };

  const buttons: ButtonPropsModel[] = [
    {
      buttonModel: {
        content: "OK",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: () => setIsErrorDialogVisible(false),
    },
  ];

  return (
    <div style={{ padding: "15px" }}>
      <Form.Row>
        <Form.Group as={Col} controlId="firstNameValidation">
          <Form.Label>Ime</Form.Label>
          <Form.Control
            type="text"
            name="firstName"
            defaultValue={data.firstName}
            autoComplete="off"
            required
          />
        </Form.Group>
        <Form.Group as={Col} controlId="lastNameValidation">
          <Form.Label>Prezime</Form.Label>
          <Form.Control
            type="text"
            name="lastName"
            defaultValue={data.lastName}
            autoComplete="off"
            required
          />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} controlId="emailValidation">
          <Form.Label>Elektronička pošta</Form.Label>
          <Form.Control
            type="email"
            name="email"
            defaultValue={data.email}
            onBlur={(event: any) => checkMail(event)}
            autoComplete="off"
            required
          />
        </Form.Group>
        <Form.Group as={Col} controlId="phoneValidation">
          <Form.Label>Telefon</Form.Label>
          <Form.Control
            type="text"
            name="phone"
            defaultValue={data.phone}
            autoComplete="off"
            required
          />
        </Form.Group>
      </Form.Row>
      {!data.id && (
        <Form.Row>
          <Form.Group as={Col} controlId="passwordValidation">
            <Form.Label>Lozinka</Form.Label>
            <Form.Control
              type={passwordType}
              name="password"
              defaultValue={data.password}
              autoComplete="new-password"
              required
            />
            <Form.Text
              onClick={() => handleClick(passwordType)}
              style={{ cursor: "pointer" }}
              muted
            >
              {passwordType === PasswordType.Text
                ? "Sakrij lozinku"
                : "Prikaži lozinku"}
            </Form.Text>
          </Form.Group>
        </Form.Row>
      )}
      <DialogComponent
        isModal={true}
        width="500px"
        className="validationErrorDialog"
        header="Greška"
        allowDragging={true}
        buttons={buttons}
        visible={isErrorDialogVisible}
      >
        <div className="dialog-content">
          <p style={{ marginBottom: 20 }}>
            <strong> Elektronička pošta </strong> već postoji:{" "}
            {<b style={{ color: "red" }}>{uniqueField}</b>}
          </p>
        </div>
      </DialogComponent>
    </div>
  );
};
